<template>
    <div class="search-results row p-3" v-if="results.length">
        <table class="table col-12">
            <tbody class="list">
                <tr
                    v-for="item in results"
                    :key="item.id"
                >
                    <td
                        v-for="(value, property) in item"
                        :key="value + 0"
                        v-if="showProperty(property)"
                    >
                        <router-link
                            :to="{ path: composeEditLink(item) }"
                            class="link"
                            v-if="property === 'name' && linkPath"
                        >
                            {{ value | uppercase }}
                        </router-link>
                        <span v-else>{{ value }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    results: {
      type: Array,
      required: true
    },
    cols: {
      type: Array,
      required: false
    },
    linkPath: {
      type: String,
      required: false
    },
    linkType: {
      default: '',
      type: String,
      required: false
    }
  },
  methods: {
    showProperty (property) {
      let show = 1
      if (this.cols.length) {
        show = this.$_.indexOf(this.cols, property)
      }
      return show !== -1
    },
    composeEditLink (item) {
      let link = this.linkPath + item.id
      if (this.linkType === 'serviceType') {
        link = this.linkPath + item.serviceType.code.toLowerCase() + '/' + item.id
      }
      return link
    }
  }
}
</script>
<style>
    .link {
        color: #0099E5 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/core/SearchResultsList.vue